module.exports = __webpack_public_path__ + "images/workspace_background.webp";